/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import PasswordDimenticata from './pages/PasswordDimenticata';
import ReimpostaPassword from './pages/ReimpostaPassword';
import Dashboard from './pages/Dashboard';
import Interventi from './pages/Interventi';
import InterventoDetail from './pages/InterventoDetail';
import Notifiche from './pages/Notifiche';
import Segnalazioni from './pages/Segnalazioni';
import Privacy from './pages/Privacy';
import { useIdentitaApp } from './hooks/useImpostazioni';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30 * 1000 } },
});

// Applica nome e icona dell'installazione a titolo della scheda e favicon.
// Sta dentro il provider di react-query perche' legge le impostazioni.
function IdentitaApp() {
  useIdentitaApp('tecnico', 'Area Tecnico');
  return null;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <IdentitaApp />
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Fuori da ProtectedRoute: ci si arriva proprio perche' non si riesce a entrare. */}
            <Route path="/password-dimenticata" element={<PasswordDimenticata />} />
            <Route path="/reimposta-password" element={<ReimpostaPassword />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/dashboard" element={<ProtectedRoute requiredRole="tecnico"><Dashboard /></ProtectedRoute>} />
            <Route path="/interventi" element={<ProtectedRoute requiredRole="tecnico"><Interventi /></ProtectedRoute>} />
            <Route path="/interventi/:id" element={<ProtectedRoute requiredRole="tecnico"><InterventoDetail /></ProtectedRoute>} />
            <Route path="/notifiche" element={<ProtectedRoute requiredRole="tecnico"><Notifiche /></ProtectedRoute>} />
            <Route path="/segnalazioni" element={<ProtectedRoute requiredRole="tecnico"><Segnalazioni /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
